"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticSessionSuccessForTenant = exports.analyticSessionResetForTenant = exports.analyticSessionFetchRecordingForTenant = exports.analyticSessionErrorForTenant = exports.analyticSessionDeleteForTenant = exports.analyticSessionCookieStatus = exports.analyticSessionAddSiteForTenant = exports.analyticSessionAddReportForTenant = exports.analyticSessionAddInitialSiteForTenant = exports.analyticSessionAddInitialReportForTenant = void 0;
var _analyticSession = require("./analyticSession.constant");
// @flow

// common success
var analyticSessionSuccessForTenant = function analyticSessionSuccessForTenant(actionType, data) {
  return {
    type: _analyticSession.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.analyticSessionSuccessForTenant = analyticSessionSuccessForTenant;
var analyticSessionErrorForTenant = function analyticSessionErrorForTenant(actionType, error) {
  return {
    type: _analyticSession.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.analyticSessionErrorForTenant = analyticSessionErrorForTenant;
var analyticSessionAddSiteForTenant = function analyticSessionAddSiteForTenant(data) {
  return {
    type: _analyticSession.actionTypes.ADD_SESSION_SITE,
    payload: data
  };
};

/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.analyticSessionAddSiteForTenant = analyticSessionAddSiteForTenant;
var analyticSessionAddReportForTenant = function analyticSessionAddReportForTenant(data) {
  return {
    type: _analyticSession.actionTypes.ADD_SESSION_REPORT,
    payload: data
  };
};

/**
 * cookie status
 * @param payload
 * @returns api response
 * @description this function used to add initial data site.
 */
exports.analyticSessionAddReportForTenant = analyticSessionAddReportForTenant;
var analyticSessionCookieStatus = function analyticSessionCookieStatus(data) {
  return {
    type: _analyticSession.actionTypes.COOKIE_STATUS,
    payload: data
  };
};

/**
 * add site
 * @param payload
 * @returns api response
 * @description this function used to add initial data site.
 */
exports.analyticSessionCookieStatus = analyticSessionCookieStatus;
var analyticSessionAddInitialSiteForTenant = function analyticSessionAddInitialSiteForTenant(data) {
  return {
    type: _analyticSession.actionTypes.INITIAL_SESSION_SITE,
    payload: data
  };
};

/**
 * add report
 * @param payload
 * @returns api response
 * @description this function used to initial add report.
 */
exports.analyticSessionAddInitialSiteForTenant = analyticSessionAddInitialSiteForTenant;
var analyticSessionAddInitialReportForTenant = function analyticSessionAddInitialReportForTenant(data) {
  return {
    type: _analyticSession.actionTypes.INITIAL_SESSION_REPORT,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.analyticSessionAddInitialReportForTenant = analyticSessionAddInitialReportForTenant;
var analyticSessionDeleteForTenant = function analyticSessionDeleteForTenant(data) {
  return {
    type: _analyticSession.actionTypes.DELETE,
    payload: data
  };
};

/**
 * fetch recording
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticSessionDeleteForTenant = analyticSessionDeleteForTenant;
var analyticSessionFetchRecordingForTenant = function analyticSessionFetchRecordingForTenant(data) {
  return {
    type: _analyticSession.actionTypes.FETCH_RECORDING,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.analyticSessionFetchRecordingForTenant = analyticSessionFetchRecordingForTenant;
var analyticSessionResetForTenant = function analyticSessionResetForTenant(data) {
  return {
    type: _analyticSession.actionTypes.RESET,
    payload: data
  };
};
exports.analyticSessionResetForTenant = analyticSessionResetForTenant;